import { filterItemsByAudience, useShouldShowContent } from 'helpers/audiencehelper';
import { ListSituation } from 'ui/components';
import { ProfileContext } from 'application/adapters/context/Profile';
import React, { useContext } from 'react';

type ListSituationsFeatureProps = {
	documentType: 'listSituation';
	content: {
		documentType: 'listSituation';
		properties: {
			heading: string;
			situationItems: Umbraco.SituationCard[];
			audiencePicker: Umbraco.AudiencePicker[];
		};
	};
};
export const ListSituationFeature: React.FC<ListSituationsFeatureProps> = ({ content }) => {
	const show = useShouldShowContent(content.properties.audiencePicker);
	const { audiences, isReady, audiencesFailed } = useContext(ProfileContext);

	// Wait for the audience lookup to settle before rendering, matching ThumbnailListFeature
	// and SituationBannerFeature.
	if (!isReady) return null;

	// Filter here with the shared helper rather than inside ListSituation, which only ever
	// applied Exclude rules and compared audience names case-sensitively.
	const situationItems = filterItemsByAudience(
		content.properties.situationItems,
		audiences,
		(situation) => situation?.properties?.audiencePicker,
		audiencesFailed,
	);

	return show ? <ListSituation {...content.properties} situationItems={situationItems} /> : null;
};
